import React from 'react';
import { Switch } from 'react-router';
import { Auth } from '@leverege/api-redux';
import { Content, Text, Flex, Pane } from '@leverege/ui-elements';
import { createConnect, Toolbar, TitleBar } from '@leverege/ui-plugin';
import { History } from '@leverege/molten-core';
import { Routes } from "../../routes/index.js";
import NetworkOffline from "../../views/NetworkOffline.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const client = 'Main';
const matchNavContext = {
  use: 'navActions',
  client
};
const matchOptionsContext = {
  use: 'headerOptions',
  client
};
class MainScreen extends React.Component {
  static client = client;
  constructor(props) {
    super(props);
    this.state = {};
  }
  getContext() {
    const {
      profile,
      username
    } = this.props;
    return {
      client: 'Main',
      mobile: true,
      clientProps: this.props,
      clientState: this.state,
      profile,
      username
    };
  }

  // eslint-disable-next-line react/no-unused-class-component-methods
  onHome = evt => {
    const {
      dispatch
    } = this.props;
    dispatch(History.push('/'));
  };
  renderTitle = () => {
    const {
      title,
      actionsMatchContext,
      actionsContext
    } = this.state;
    let comp = title;
    if (typeof title === 'function') {
      comp = title(this.getContext());
    } else if (typeof title === 'string') {
      comp = /*#__PURE__*/_jsx(Text, {
        variant: "mobileScreenTitle|screenTitle",
        children: title
      });
    }
    return /*#__PURE__*/_jsxs(Content.Header, {
      children: [/*#__PURE__*/_jsxs(TitleBar, {
        variant: "mobileMainHeader",
        title: null,
        children: [comp, /*#__PURE__*/_jsxs(Flex, {
          children: [actionsMatchContext && actionsContext ? /*#__PURE__*/_jsx(Toolbar, {
            variant: "mobileActionBar|actionBar",
            prefer: "icon",
            matchContext: matchOptionsContext,
            context: this.getContext()
          }) : null, /*#__PURE__*/_jsx(Toolbar, {
            variant: "mobileActionBar|actionBar",
            matchContext: matchNavContext,
            context: this.getContext()
          })]
        })]
      }), /*#__PURE__*/_jsx(Pane, {
        variant: "mobileTopNavBreadcrumbs|topNavBreadcrumbs",
        children: Routes.getRoutesFor('Main', 'Breadcrumbs', {
          client: 'Breadcrumbs'
        }, {
          mobile: true
        }, false)
      }), /*#__PURE__*/_jsx(NetworkOffline, {})]
    });
  };
  setTitle = ({
    data
  }) => {
    this.setState({
      title: data
    });
  };
  setActionsContext = ({
    data
  }) => {
    this.setState({
      actionsContext: data
    });
  };
  setActionsMatchContext = ({
    data
  }) => {
    this.setState({
      actionsMatchContext: data
    });
  };
  render() {
    const {
      setTitle,
      setActionsMatchContext,
      setActionsContext
    } = this;
    return /*#__PURE__*/_jsxs(Content, {
      style: {
        zIndex: 0
      },
      children: [this.renderTitle(), /*#__PURE__*/_jsx(Content.Area, {
        children: /*#__PURE__*/_jsx(Switch, {
          children: Routes.getRoutesFor('Main', null, {
            client
          }, {
            setTitle,
            setActionsContext,
            setActionsMatchContext
          })
        })
      })]
    });
  }
}
const connect = createConnect('Main', {
  client
});
export default connect(state => {
  return {
    profile: Auth.getProfile(state.auth),
    username: Auth.getUsername(state.auth)
  };
})(MainScreen);